import { getFirestore } from 'firebase/firestore/lite';
import 'firebase/compat/firestore';
import 'firebase/compat/auth';
import { 
	createUserWithEmailAndPassword, 
	FacebookAuthProvider,
	getAuth,
	GoogleAuthProvider,
	signInWithEmailAndPassword,
	signInWithPopup,
	signOut
} from 'firebase/auth'
import { initializeApp } from "firebase/app"
import firebaseConfig from 'configs/FirebaseConfig';

const firebaseApp = initializeApp(firebaseConfig);

const db = getFirestore(firebaseApp);
const auth = getAuth(firebaseApp);
const currentUser = auth.currentUser
const googleAuthProvider = new GoogleAuthProvider();
const facebookAuthProvider = new FacebookAuthProvider();

export {
	auth,
	createUserWithEmailAndPassword,
	currentUser,
	db,
	facebookAuthProvider,
	FacebookAuthProvider,
	googleAuthProvider,
	GoogleAuthProvider,
	signInWithEmailAndPassword,
	signInWithPopup,
	signOut
};